/**
 * @fileoverview Common schemas for pagination and error responses

 */

import { z } from '@hono/zod-openapi';

// Common schemas used across the application
export const PaginationSchema = z
  .object({
    limit: z.number().int().positive().max(100).default(20).openapi({
      description: 'Maximum number of items to return',
      example: 20,
    }),
    cursor: z.string().optional().openapi({
      description: 'Cursor for pagination',
      example: 'eyJpZCI6IjEyMyJ9',
    }),
  })
  .openapi('Pagination');

export const ErrorResponseSchema = z
  .object({
    error: z.string().openapi({
      description: 'Error message',
      example: 'Invalid request',
    }),
    details: z
      .array(z.any())
      .optional()
      .openapi({
        description: 'Additional error details',
        example: [{ field: 'email', message: 'Invalid email format' }],
      }),
  })
  .openapi('ErrorResponse');

// Utility function for creating paginated list response schemas
export const createListResponseSchema = (schema, itemName, schemaName) => {
  return z
    .object({
      [itemName]: z.array(schema).openapi({
        description: `Array of ${itemName}`,
      }),
      cursor: z.string().nullable().openapi({
        description: 'Cursor for pagination',
        example: 'eyJpZCI6IjEyMyJ9',
      }),
      hasMore: z.boolean().openapi({
        description: `Whether there are more ${itemName} to fetch`,
        example: true,
      }),
    })
    .openapi(schemaName);
};
